var map = {
	"./01-01.mp3": 489,
	"./01-01__.mp3": 761,
	"./01-02.mp3": 762,
	"./01-03.mp3": 355,
	"./01-04.mp3": 356,
	"./01-05.mp3": 490,
	"./01-06.mp3": 763,
	"./01-07.mp3": 764,
	"./01-08.mp3": 765,
	"./01-09.mp3": 766,
	"./01-10.mp3": 767,
	"./01-11.mp3": 805,
	"./01-12.mp3": 1525,
	"./01-13.mp3": 1526,
	"./01-14.mp3": 806,
	"./04-01.mp3": 1527,
	"./04-02.mp3": 1528,
	"./04-03.mp3": 807,
	"./04.mp3": 1529,
	"./emotion-slow.mp3": 808,
	"./emotion.mp3": 1530,
	"./ex1-slow.mp3": 809,
	"./ex1.mp3": 1531,
	"./ex1_3_4-slow.mp3": 810,
	"./ex1_3_4.mp3": 1532,
	"./ex7-slow.mp3": 811,
	"./ex7.mp3": 1533,
	"./ex8-slow.mp3": 812,
	"./ex8.mp3": 1534,
	"./health-slow.mp3": 813,
	"./health.mp3": 1535,
	"./intoSleep.mp3": 498,
	"./life-cycle-slow.mp3": 814,
	"./life-cycle.mp3": 1536,
	"./life-slow.mp3": 815,
	"./life.mp3": 1537,
	"./natureFeedback.mp3": 1538,
	"./natureFeedbackEffect.mp3": 816,
	"./recognition-slow.mp3": 817,
	"./recognition.mp3": 1539,
	"./soundAlpha.mp3": 1540,
	"./soundAlpha1.mp3": 1541,
	"./soundAlpha2.mp3": 1542,
	"./soundAttemption.mp3": 768,
	"./soundAttemptionNew.mp3": 1543,
	"./soundBalance.mp3": 770,
	"./soundBalanceF.mp3": 1544,
	"./soundBalanceNew.mp3": 1545,
	"./soundConst.mp3": 769,
	"./soundConstNew.mp3": 1546,
	"./soundRest.mp3": 357,
	"./soundRestNew.mp3": 1547,
	"./view5-ex1-slow.mp3": 818,
	"./view8-ex1-slow.mp3": 819,
	"./view9-ex1-slow.mp3": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1524;